module.exports = __webpack_public_path__ + "static-v-shop/1770130202702/img/ic-ingredientes.859c890a.png";